import { render, staticRenderFns } from "./VideoRoom.vue?vue&type=template&id=644caae7"
import script from "./VideoRoom.vue?vue&type=script&lang=js"
export * from "./VideoRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports